'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const IntegrityTrendChart = dynamic(
  () => import('./charts/IntegrityTrendChart'),
  { ssr: false, loading: () => <div className="h-[220px] animate-pulse bg-muted rounded-xl" /> }
);

const IceLossChart = dynamic(
  () => import('./charts/IceLossChart'),
  { ssr: false, loading: () => <div className="h-[220px] animate-pulse bg-muted rounded-xl" /> }
);

export default function ArcticChartsRow() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-5 mt-5">
      <div className="bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">Shelf Integrity Trend — 12 Months</p>
          <p className="text-xs text-muted-foreground">Integrity index 0–100 per shelf region</p>
        </div>
        <IntegrityTrendChart />
        <div className="flex flex-wrap gap-3 mt-3">
          {[
            { id: 'leg-thwaites', color: 'bg-negative', label: 'Thwaites' },
            { id: 'leg-pine', color: 'bg-warning', label: 'Pine Island' },
            { id: 'leg-larsen', color: 'bg-primary', label: 'Larsen C' },
            { id: 'leg-ronne', color: 'bg-positive', label: 'Ronne' },
            { id: 'leg-ross', color: 'bg-accent', label: 'Ross' },
          ]?.map((l) => (
            <div key={l?.id} className="flex items-center gap-1.5">
              <span className={`w-2 h-2 rounded-full ${l?.color}`} />
              <span className="text-[10px] text-muted-foreground">{l?.label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">Ice Loss Rate Trend — 12 Months</p>
          <p className="text-xs text-muted-foreground">km³/year — combined shelf loss rate</p>
        </div>
        <IceLossChart />
      </div>
    </div>
  );
}